/* TABS 

<div class="Tabs ">
  <div class="navigation">
    <ul>
      <li class="tab tab-primary active"><p></p></li>
      <li class="tab tab-primary"><p></p></li>
      <li class="tab tab-primary"><p></p></li>
      <div class="focus-el el--1"></div>
      <div class="focus-el el--2"></div>
    </ul>
  </div>
  <div class="content">
    <div class="wp-block wp-block-group tab tab-primary active"></div>
    <div class="wp-block wp-block-group tab tab-primary"></div>
    <div class="wp-block wp-block-group tab tab-primary"></div>
  </div>
</div>

*/

// sets up Tabs
var Tabs = $('.Tabs');
var T = 0;
var s = 0;
var n = 0;
var c = 0;
var ndi = 0;
var cdi = 0;

// adds index to corresponding sections for each Tab
Tabs.each(function () {
  var section = $(this).closest('Tabs');
  var nav = $(this).find('.navigation');
  var content = $(this).find('.content');

  $(this).attr('tab-index', T++);
  section.attr('section-index', s++);
  nav.attr('nav-index', n++);
  content.attr('content-index', c++);

  // adds matching data-index to each Tab section for navigation
  nav.find('ul').children().each(function () {
    $(this).attr("data-index", ndi++);
  });
  content.children().each(function () {
    $(this).attr("data-index", cdi++);
  });
});

// displays appropriate content per selected tab
$('.Tabs .navigation .tab').click(function () {
  var activeTab = $(this).data('index');
  var tabSection = $(this).closest('.Tabs').attr('tab-index');

  $('.Tabs .navigation[nav-index="' + tabSection + '"] ul').children().removeClass('active');
  $('.Tabs .navigation[nav-index="' + tabSection + '"] ul .tab[data-index="' + activeTab + '"]').addClass('active');

  $('.Tabs .content[content-index="' + tabSection + '"]').children().removeClass('active');
  $('.Tabs .content[content-index="' + tabSection + '"] .tab[data-index="' + activeTab + '"]').addClass('active');
});